(function () {
	const els = document.querySelectorAll(`[data-to-top]`);
	if (els.length === 0) {
		return;
	}

	function scroll() {
		window.scrollTo(0, 0);
	}

	for (let i = 0; i < els.length; i++) {
		els[i].addEventListener(`click`, scroll);
	}
})();
